module.exports = __webpack_public_path__ + "img/item_part_cadence_sensor.1a32c931.png";